import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { HallsResponse } from "../../models/dtos";

export const hallsApi = createApi({
  reducerPath: 'hallsApi',
  baseQuery: baseAuthQuery('Halls'),
  tagTypes: ['Hall'],
  endpoints: (builder) => ({
    getHalls: builder.query<ApiResponse<HallsResponse[]>, void>({
      query: () => "",
      providesTags: ['Hall'],
    }),
  }),
});
